import React, { useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import BackButton from './BackButton';
import Store from './Store';
import Bank from './Bank';
import Review from './Review/Review';
import NoContent from '../misc/Message';
import { ESellerStore } from 'frontend/src/Types/business';

const useStyles = makeStyles((theme) => ({
  stepperRoot: { paddingTop: theme.spacing(4) },
}));

export default function Stepper({
  hasBank,
  plaidLinkToken,
  business,
  lines,
  amzAccounts,
  setHasBank,
  setBusiness,
  setLoading,
}) {
  const classes = useStyles();
  let initialStep = 1;
  if (business?.sellerStore === ESellerStore.amazon) {
    initialStep = 2;
  }
  const [step, setStep] = useState(initialStep);

  function goForward() {
    if (step === 1 && hasBank) {
      setStep(step + 2);
    } else {
      setStep(step + 1);
    }
  }

  function goBack() {
    if (step === 3 && hasBank) {
      setStep(step - 2);
    } else if (step > 1) {
      setStep(step - 1);
    }
  }

  return (
    <div>
      {lines.length === 0 && (
        <NoContent
          text="It looks like you don't have any Lines selected. You can't submit a
        Growth Plan without a Line."
        />
      )}

      {lines.length > 0 && (
        <>
          <BackButton goBack={goBack} isFirstPage={step === 1} />
          <div className={classes.stepperRoot}>
            {step === 1 && (
              <Store
                amzAccounts={amzAccounts}
                lines={lines}
                goForward={goForward}
                business={business}
              />
            )}
            {step === 2 && (
              <Bank
                goForward={goForward}
                plaidLinkToken={plaidLinkToken}
                hasBank={hasBank}
                setHasBank={setHasBank}
              />
            )}
            {step === 3 && (
              <Review
                lines={lines}
                business={business}
                setBusiness={setBusiness}
                setLoading={setLoading}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
}
